import React, { useState } from 'react';
import { MessageSquare, MoreHorizontal, Tag, CheckSquare } from 'lucide-react';
import { Avatar } from '../ui/Avatar';
import { Badge } from '../ui/Badge';
import { Button } from '../ui/Button';
import { Insight } from '../../types/workspace';
interface InsightCardProps {
  insight: Insight;
}
export function InsightCard({
  insight
}: InsightCardProps) {
  const [showComments, setShowComments] = useState(false);
  return <div className="border border-gray-200 rounded-lg bg-white shadow-sm hover:shadow transition-shadow" data-id="element-78">
      <div className="p-4" data-id="element-79">
        <div className="flex justify-between items-start" data-id="element-80">
          <Badge variant={insight.sentiment === 'positive' ? 'success' : insight.sentiment === 'negative' ? 'danger' : 'default'} data-id="element-81">
            {insight.sentiment}
          </Badge>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-82">
            <MoreHorizontal size={16} data-id="element-83" />
          </button>
        </div>
        <h3 className="font-medium text-gray-900 mt-2" data-id="element-84">{insight.title}</h3>
        <p className="text-sm text-gray-500 mt-1" data-id="element-85">{insight.description}</p>
        <div className="mt-4 flex items-center space-x-2" data-id="element-86">
          {insight.tags.map((tag, index) => <div key={index} className="flex items-center text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded" data-id="element-87">
              <Tag size={12} className="mr-1" data-id="element-88" />
              {tag}
            </div>)}
        </div>
      </div>
      <div className="border-t border-gray-200 px-4 py-3 flex justify-between items-center" data-id="element-89">
        <div className="flex items-center space-x-4" data-id="element-90">
          <button onClick={() => setShowComments(!showComments)} className="flex items-center text-sm text-gray-500 hover:text-gray-700" data-id="element-91">
            <MessageSquare size={16} className="mr-1" data-id="element-92" />
            {insight.comments.length}
          </button>
          <button className="flex items-center text-sm text-gray-500 hover:text-gray-700" data-id="element-93">
            <CheckSquare size={16} className="mr-1" data-id="element-94" />
            {insight.actions.length}
          </button>
        </div>
        <div data-id="element-95">
          <Avatar name={insight.author.name} src={insight.author.avatar} size="sm" data-id="element-96" />
        </div>
      </div>
      {showComments && <div className="border-t border-gray-200 p-4 bg-gray-50" data-id="element-97">
          <h4 className="text-sm font-medium mb-2" data-id="element-98">Comments</h4>
          {insight.comments.length === 0 ? <p className="text-sm text-gray-500" data-id="element-99">No comments yet</p> : <div className="space-y-3" data-id="element-100">
              {insight.comments.map((comment, index) => <div key={index} className="flex space-x-2" data-id="element-101">
                  <Avatar name={comment.author.name} src={comment.author.avatar} size="sm" data-id="element-102" />
                  <div className="flex-1" data-id="element-103">
                    <div className="bg-white p-2 rounded-lg border border-gray-200" data-id="element-104">
                      <div className="flex justify-between" data-id="element-105">
                        <span className="text-xs font-medium" data-id="element-106">
                          {comment.author.name}
                        </span>
                        <span className="text-xs text-gray-500" data-id="element-107">
                          {comment.date}
                        </span>
                      </div>
                      <p className="text-sm mt-1" data-id="element-108">{comment.text}</p>
                    </div>
                  </div>
                </div>)}
            </div>}
          <div className="mt-3 flex space-x-2" data-id="element-109">
            <input type="text" placeholder="Add a comment..." className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm" data-id="element-110" />
            <Button size="sm" data-id="element-111">Post</Button>
          </div>
        </div>}
    </div>;
}